/** Shared by OAuth start/callback routes and the module catalog. */
const RETURN_BASE = 'https://attune.invalid';
export const DEFAULT_INTEGRATION_RETURN = '/app/workspace?mode=integrations';

export function safeIntegrationReturnPath(
  value: unknown,
  fallback = DEFAULT_INTEGRATION_RETURN
): string {
  if (
    typeof value !== 'string' ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    /[\\\u0000-\u0020\u007f]/.test(value)
  )
    return fallback;
  try {
    const url = new URL(value, RETURN_BASE);
    const pathname = decodeURIComponent(url.pathname);
    if (
      url.origin !== RETURN_BASE ||
      (pathname !== '/app' && !pathname.startsWith('/app/')) ||
      /[\\\u0000-\u0020\u007f]/.test(pathname)
    )
      return fallback;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}

export function integrationSetupReturnPath(
  moduleId: string,
  returnTo?: string,
  desktop = false
): string {
  const url = new URL(safeIntegrationReturnPath(returnTo), RETURN_BASE);
  url.searchParams.set('setup_module', moduleId);
  if (desktop) url.searchParams.set('desktop_oauth', '1');
  return `${url.pathname}${url.search}${url.hash}`;
}

export function integrationCallbackUrl(
  appUrl: string,
  returnTo: unknown,
  values: Record<string, string>
): URL {
  const url = new URL(safeIntegrationReturnPath(returnTo), appUrl);
  for (const [key, value] of Object.entries(values)) url.searchParams.set(key, value);
  if (url.searchParams.get('desktop_oauth') === '1') {
    url.searchParams.delete('desktop_oauth');
    const desktopUrl = new URL('attune://open');
    desktopUrl.searchParams.set('path', `${url.pathname}${url.search}${url.hash}`);
    return desktopUrl;
  }
  return url;
}
